import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_account_entitlement_hdr_RowClass,
} from '../../../dbschema';

export class ClaimAccountEntitlementContainerModel extends BaseContainerModel {
  bl_aat_claim_account_entitlement_hdr: bl_aat_claim_account_entitlement_hdr_RowClass = new bl_aat_claim_account_entitlement_hdr_RowClass();
}
